import { Button, Color, Flex, Icon, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface FecImportSuccessStepProps {
  onClose: () => void
}

export const FecImportSuccessStep = ({ onClose }: FecImportSuccessStepProps): ReactElement => {
  const { t } = useTranslation()

  const handleCloseButtonClick = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <Styled.SuccessStepWrapper>
      <Styled.SuccessSquircle>
        <Icon aria-hidden="true" color={Color.Grey950} icon="check" size="lg" />
      </Styled.SuccessSquircle>
      <Flex alignItems="center" flexDirection="column" gap={Spacing.S24} width="100%">
        <Styled.SuccessCopy>
          <Text alignment="center" colorVariant="primary" variant="h2">
            {t('settings.organization.accounting.fec_file_import.modal.success_step.title')}
          </Text>
          <Text alignment="center" colorVariant="secondary" variant="bodyMD">
            {t('settings.organization.accounting.fec_file_import.modal.success_step.description')}
          </Text>
        </Styled.SuccessCopy>
        <Button onClick={handleCloseButtonClick} variant="filled">
          {t('settings.organization.accounting.fec_file_import.modal.success_step.close_button')}
        </Button>
      </Flex>
    </Styled.SuccessStepWrapper>
  )
}
